import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ParamMapping {
  type: 'field' | 'static';
  value: string;
}

@Component({
  selector: 'app-wp-param-mapping-dialog',
  templateUrl: './wp-param-mapping-dialog.component.html',
  styleUrls: ['./wp-param-mapping-dialog.component.scss']
})
export class WpParamMappingDialogComponent {

  params: ParamMapping[] = [
    { type: 'field', value: this.data.customerFields[0] || 'name' }
  ];

  constructor(
    public dialogRef: MatDialogRef<WpParamMappingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { campaignName: string; customerFields: string[] }
  ) {}

  addParam() {
    this.params.push({ type: 'field', value: this.data.customerFields[0] || '' });
  }

  removeParam(index: number) {
    this.params.splice(index, 1);
  }

  confirm() {
    this.dialogRef.close(this.params);
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
